import { toastError } from '@onestep/coreui/Toast';
import { observer } from 'mobx-react-lite';

import profileImage from '../../../../../../../assets/images/patients/profile.svg?url';
import useIntakeData from '../../../../../../../services/intakeDataService/index';
import useInviteSmsService from '../../../../../../../services/intakeDataService/inviteSmsService/index';
import { add } from '../../../../../../../services/timeService';
import { unitOfTime } from '../../../../../../../services/timeService/types';
import styles from './index.module.scss';

export const LINK_TIMER = 59;

const ProfileContent = ({
  patientUuid,
  timer,
  setTimer,
}: {
  patientUuid?: string;
  timer: number;
  setTimer: (timer: Date) => void;
}) => {
  const { state } = useIntakeData();

  const { sendInviteSms } = useInviteSmsService();

  const resendCode = async () => {
    if (patientUuid && state?.phoneNumber) {
      try {
        setTimer(add(unitOfTime.seconds, LINK_TIMER).toDate());
        await sendInviteSms({
          phoneNumber: `+${state.phoneNumber}`,
          patientUuid,
          force: true,
        });
      } catch {
        toastError({ content: `Failed to invite patient` });
      }
    }
  };

  return (
    <div className={styles.innerGap}>
      <div className="flex flex-col gap-4">
        <span>
          <span className="pr-2">Patient hasn't received the invite yet?</span>
          {timer > 0 ? (
            <span className="font-semibold ">Resend Invite (00:{timer})</span>
          ) : (
            <span className={styles.link} onClick={resendCode}>
              Resend Invite
            </span>
          )}
        </span>
        <div>
          You can see if the patient has joined at any time by checking for a registered phone
          number. This is done through the personal information section under the 'Profile' tab on
          the patient's page.
        </div>
      </div>
      <img src={profileImage} className={styles.profileImg} />
    </div>
  );
};

export default observer(ProfileContent);
